import React, { useRef, useState, useEffect } from "react";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "context/baseUrl/baseUrl";
import { Link, useHistory } from "react-router-dom";
import FormSection from "components/form/FormSection";
import Loader from "components/loader/loader";
import { trim } from "lodash";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Multiselect from "multiselect-react-dropdown";
import Col from "react-bootstrap/Col";
import MainLayout from "components/mainLayout/MainLayout";
import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import DropdownFilter from "components/input/dropdown/dropDownFilter";
import "./Utr.scss";

let timerId = null;
const Utr = ({ match }) => {

  const [activeComponent, setActiveComponent] = useState();
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [addUTRData, setAddUTRData] = useState({
    partnerName: "",
    partnerCode: "",
    lanNoCount: "",
    partnerId: null,
  });
  const [errMsg, setErrMsg] = useState({
    partnerName: "",
    partnerCode: "",
    partnerEmail: "",
    partnerWebhookUrl: "",
    lanNoCount: "",  
    lanNoLength: "",  
  });

  const scrl = useRef(null);

  useEffect(() => {
    (async () => {
      getLanCount();
      getPartnerList();      
    })();


  }, []);

  const [isLoading, setisLoading] = useState(false);
  const [pageNos, setPageNo] = useState("1");
  const [show, setShow] = useState(false);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [partnerData, setPartnerData] = useState([]);
  const [partnerName, setPartnerName] = useState("");
  const [partnerId, setPartnerId] = useState("");
  const [partnerList, setPartnerList] = useState([]);
  const [editPartner, setEditPartner] = useState(false);
  const [partnerDisable, setPartnerDisable] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [partnerArray, setPartnerArray] = useState([]);
  
  const [finTypeCheckbox, setDocFormatCheckboc] = useState([]);
  const [isPartner, setIsPartner] = useState(false);
  const [lanNoCheck, setLanNoCheck] = useState([]);
  const [lanCount, setLanCount] = useState("");
  const [isUtrSubmit, setIsUtrSubmit] = useState(true);
  const [finTypeOptions, setFinTypeOptions] = useState([]);
  const [invalidLanNumbers, setInvalidLanNumbers] = useState([]);

  const [lanCountNumber, setLanCountNumber] = useState([
    {id:1, name: 1},
    {id:2, name: 2},
    {id:3, name: 3},
    {id:4, name: 4},
    {id:5, name: 5},
    {id:6, name: 6},
    {id:7, name: 7},
    {id:8, name: 8},
    {id:9, name: 9},
    {id: 10, name: 10}
  ]);

  const getLanNumberData = async () => {
    const lanNoCount = lanCount;
    if (lanNoCheck.length == 0 || lanNoCheck.length > lanNoCount) {
      setErrMsg((state) => ({
        ...state,
        lanNoLength: "Select maximum " + " " + lanNoCount + " " + "Lan Number",
      }));
      return 
    } else {
      setErrMsg((state) => ({
        ...state,
        lanNoCount: "",
      }))
    }
    const dataArray = [];
    lanNoCheck.forEach((f) => {
      dataArray.push(f.name);
    });
    const data = {
      finReferences: dataArray
    };
    setisLoading(true);
    const res = await callWebService(
      callTypes.post,
      data,
      Config.getUtrFromLan
    );
    setisLoading(false);
    setErrMsg((state) => ({
      ...state,
      lanNoLength: "",
    }));
    setPartnerData(res.data.data);
  };


  const onSelect = (selectedList, selectedItem) => {
    if (selectedList) {
      const lanCountNumbera = addUTRData.lanNoCount;
      setLanNoCheck(selectedList);

      if (selectedList.length <= lanCountNumbera) {
        setIsUtrSubmit(false);
      } else {
        setErrMsg((state) => ({
          ...state,
          lanNoLength: "Select maximum " + " " + lanCountNumbera + " " + "Lan Number",
        }));
        setIsUtrSubmit(true);
      }
    }
  };
  const onSearch = (value) => {
    const results = value ? finTypeCheckbox.filter(w => w.name?.includes(value)) : [];
        setTimeout(r => { 
          setFinTypeOptions(r);
        }, 400, results)
  }


  const keyPressLan = (event, value) => {
    timerId && clearTimeout(timerId);
    if (!value) return true;
    timerId = setTimeout(() => keyPressLanFn(event, value), 5000);
  }

  const keyPressLanFn = (event, value) => {
    const validArray = [];
    finTypeCheckbox.forEach(f => {
      validArray.push(f.name);
    })
    const invalidLanCheck = invalidLanNumbers.includes(value?.toUpperCase());
    const validLanCheck = validArray.includes(value?.toUpperCase());
    if (invalidLanCheck) {
      alert('Disbursement for LAN - '+ value + ' is not done yet');
    } else if (!validLanCheck) {
      alert('Please enter a valid LAN Number');
    }
  }

  const onRemove = (selectedList, removedItem) => {
    if (selectedList.length > 0) {
      const lanCountNumbera = addUTRData.lanNoCount;
      setLanNoCheck(selectedList);

      if (selectedList.length <= lanCountNumbera) {
        setErrMsg((state) => ({
          ...state,
          lanNoLength: "",
        }));
        setIsUtrSubmit(false);
      } 
    } else {
      setTimeout(() => {
        setFinTypeOptions([]);
      }, 400);
      setIsUtrSubmit(true);
    }    
  };

  const getLanCount = async () => {
    const data ={
      action: "list",      
      utr_master_id: 1,
    }
    const res = await callWebService(callTypes.post, data, Config.utrOperation);
    if (res.data.code === 200 || res.data.code === true) {
      setErrorMsg("");
      setAddUTRData({
        lanNoCount: res.data.data.utr_master_list[0].utr_count
      });
      setErrMsg({
        lanNoCount: "",
      });
    } else if (res.data.code === 400) {
      setErrorMsg(res.data.data[0].message);
      setIsSubmit(false);
    }
  }


  const lanNoList = async (data) => {
    setisLoading(true);
    const partnerData = {
      partnerCode: data
    }
    const res = await callWebService(
      callTypes.post,
      partnerData,
      Config.getLanNo
      );
      if (res?.data?.data == undefined) {
        setisLoading(false);
        return;
      }
      const lanArray = [];
      const {validLanNumbers, lanCount, invalidLanNumbers} = res?.data?.data;
      setLanCount(lanCount);
      if (validLanNumbers || invalidLanNumbers) {
      setIsPartner(true);
      setInvalidLanNumbers(invalidLanNumbers);
      validLanNumbers.filter(f =>f !== null).forEach(f => {
        let obj = {
          name: f,
          id: f
        }
        lanArray.push(obj);
      })
      setDocFormatCheckboc(lanArray);
      setisLoading(false);
      }

  }

  const getPartnerList = async () => {
    setisLoading(true);
    const res = await callWebService(
      callTypes.get,
     {},
      Config.getPartnerFullList
    );

    const lanArray = [];
    const lanData = res?.data?.data?.partnerList;

    if (lanData) {
      setPartnerArray(lanData);
      lanData.filter(f =>f !== null).forEach(f => {
        let obj = {
          name: f.name,
          id: f.partner_code
        }
        lanArray.push(obj);
      })

      setPartnerList(lanArray);
      setisLoading(false)
    }
  }


  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "Digital Alliance Application No",
      "LAN Number",
      "UTR Number",
    ];

    return headerElement.map((key, index) => {     
        return <th key={index}>{key}</th>;
    });
  };

  const onChangePartner = async (e) => {
    const data = e.target.value;
    setPartnerName(data);
    if (data) {
      setLanNoCheck([]);
      setPartnerData([]);
      const ab = partnerArray.filter(f => f.partner_code == data);
      const partnerId = ab[0]?.id;
      setPartnerId(partnerId);
      lanNoList(data);
    }
  };

  const filterData = () => {
    const partnerData = trim(partnerName);
    if (partnerData) {
      setPartnerName(partnerData);
      getLanNumberData();
    }
  };

  const handleClose = () => {
    setShow(false);
    setIsSubmit(false);
    setEditPartner(true);
    setErrMsg({
      lanNoCount: "",
    });
  };
  const handleShow = () => {
    setShow(true);
    setPartnerDisable(false);
    setEditPartner(false);
  };

  const partnerChange = (e) => {
    const { name, value } = e.target;    
    setAddUTRData((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async () => {

    if (addUTRData.lanNoCount === "") {
      setErrMsg((state) => ({
        ...state,
        lanNoCount: "Enter lan Number Count",
      }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, lanNoCount: "" }));
    }

    setIsSubmit(true);

    const userName = localStorage.getItem('username');
    const ab = partnerArray.filter(f => f.partner_code == partnerName);
    const partnerId = ab[0]?.id;
    setPartnerId(partnerId);
    const data ={
      action: "edit",
      partner_name: partnerName,
      partner_id: partnerId,
      utr_count: addUTRData.lanNoCount,
      reqUsername: userName,
      utr_master_id: 1,
      pageSize: 10,
      pageNo: 1,
      searchName: partnerName
    }
    const res = await callWebService(callTypes.post, data, Config.utrOperation);
    if (res.data.code === 200 || res.data.code === true) {
      setErrorMsg("");
      setSuccessMsg(res.data.message);
      setIsSubmit(false);
      setAddUTRData({
        lanNoCount: "",
        partnerId: null,
      });
      setErrMsg({
        lanNoCount: "",
      });
      setTimeout(() => {
        document.location.reload();
      }, 500);
    } else if (res.data.code === 400) {
      setErrorMsg(res.data.data[0].message);
      setIsSubmit(false);
    }
  };

  
  const blockInvalidChar = (e) => {
    ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();
  }
  const inputSearch = () => {
    return (
      <>
        <div style={{ display: "inline-block" }}>
          <div className="dropdown1" style={{ float: "none", width: "200px" }}>
            <DropdownFilter
              value={partnerName}
              name="partnerName"
              optionList={partnerList}
              optIdKey="id"
              optValueKey="name"
              placeholder="Partner Name"
              onChange={(e) => onChangePartner(e)}
            />
          </div>  &nbsp;
          {isPartner ?
            <>
            <div className="dropdown1 search-button" style={{ float: "none", border: "0", width: "606px" }}>
              <span style={{ color: "red", display: "flex" }}>{errMsg.lanNoLength} &nbsp;
               <small id="emailHelp" className="form-text text-muted">Press Enter to add LAN Number</small>
              
              </span>

                  <Multiselect
                    // options={finTypeCheckbox}
                    options={finTypeOptions}
                    selectedValues={lanNoCheck}
                    onSelect={onSelect}
                    onRemove={onRemove}
                    onSearch={onSearch}
                    displayValue="name"
                    placeholder="Enter LAN Number"
                    selectionLimit={addUTRData.lanNoCount+1}
                    onKeyPressFn={keyPressLan}
                  />
            </div>
            &nbsp;
            <button className="btn btn-primary" onClick={() => filterData()} disabled={isUtrSubmit}>
              Get UTR
            </button>
             </>
          : "" }
        </div>
          <button
            style={{ float: "right" }}
            className="btn btn-primary mr-2"
            onClick={() => handleShow()}
          >
            LAN Count
          </button> 
         {/* {isPartner ? */}
         <>
          &nbsp;
          <Link
           style={{ float: "right" }}
            to={{
              pathname: "/utr-history"
              // pathname: `/utr-history/${partnerId}`
            }}
            className="btn btn-primary mr-2"
          >
             History
          </Link>
        </>
        {/* : ""} */}
       
      </>
    );
  };

  const filterSearch = () => {

  }

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout activeComponent={activeComponent} match={match}>
        <Layout
          title={localization.utr}
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
          <FormSection
             search={true}
             inputSearch={inputSearch}
             filterSearch={filterSearch}
             sortBy={() => {}}
             isCheck={isCheck}
          >
            <div className="panel-card-table" ref={scrl} style={{width: "100%", overflow: "auto"}}>
              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}</tr>
                </thead>
                <tbody>
                  {partnerData &&
                    partnerData.map((data, idx) => (
                      <tr key={idx}>
                        <td>{pageNos === 1 ? idx + 1 : (pageNos - 1) * perPageRecord + idx + 1 }</td>
                        <td>{data.da_application}</td>
                        <td>{data.lan_number}</td>
                        <td>{data.utr}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </FormSection>
          <Loader isLoading={isLoading} />

          <Modal className="dms-modal" show={show} onHide={handleClose}>
            <Modal.Header closeButton style={{ backgroundColor: "#f7fcfd" }}>
              <Modal.Title>Edit LAN Number Count &nbsp;
                <span
                  style={{
                    color: successMsg ? "green" : "red",
                    fontSize: "small",
                  }}
                >
                {successMsg ? successMsg : errorMsg}
                </span>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: "" }} className="partner-p">
              <Col>
                <label className="mt-3">Enter Count Number of LAN number </label>
                {/* <input
                  type="number"
                  name="lanNoCount"
                  min="1"
                  maxLength="3"
                  pattern="([0-9]|[0-9]|[0-9])" 
                  className="search-button partner-search"
                  placeholder="Enter Count Number of LAN number..."
                  value={addUTRData.lanNoCount || ""}
                  onChange={(e) =>  partnerChange(e)}
                  onKeyDown={blockInvalidChar}
                /> */}
                <DropdownFilter
                  value={addUTRData.lanNoCount || ""}
                  name="lanNoCount"
                  optionList={lanCountNumber}
                  optIdKey="id"
                  optValueKey="name"
                  placeholder="Enter Count Number of LAN number..."
                  onChange={(e) => partnerChange(e)}
                />
                <br />
                <span style={{ color: "red" }}>{errMsg.lanNoCount}</span>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="default" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSubmit}>
                {isSubmit ? "Loading..." : "Submit"}
              </Button>
            </Modal.Footer>
          </Modal>        
        </Layout>
        <div className="mobile-view container">
          <h3>{localization.label.myLead}</h3>
          <div className="my-lead-wrap">
          </div>
        </div>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default Utr;
